import { render, staticRenderFns } from "./invitationOffer.vue?vue&type=template&id=68b9af6c&scoped=true&"
import script from "./invitationOffer.vue?vue&type=script&lang=js&"
export * from "./invitationOffer.vue?vue&type=script&lang=js&"
import style0 from "./invitationOffer.vue?vue&type=style&index=0&id=68b9af6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9af6c",
  null
  
)

export default component.exports